import React from 'react';
import './tabbed-modal-layout.scss';

export interface TabDef {
  id: string;
  label: React.ReactNode;
  /** A 14px stroke icon before the label. */
  icon?: React.ReactNode;
  hidden?: boolean;
}

interface TabbedModalLayoutProps {
  tabs: TabDef[];
  activeTabId: string;
  onTabChange: (id: string) => void;
  sidebar?: React.ReactNode;
  children: React.ReactNode;
}

const TabbedModalLayout: React.FC<TabbedModalLayoutProps> = ({
  tabs,
  activeTabId,
  onTabChange,
  sidebar,
  children,
}) => {
  const visibleTabs = tabs.filter((t) => !t.hidden);

  return (
    <div className="tabbed-modal-layout">
      <div className="tabbed-modal-layout__content-wrapper">
        <div className="tabbed-modal-layout__main">
          <div className="tabbed-modal-layout__tabs">
            <div className="tabbed-modal-layout__track" role="tablist">
              {visibleTabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  aria-selected={activeTabId === tab.id}
                  className={`tab-button ${activeTabId === tab.id ? 'active' : ''}`}
                  onClick={() => onTabChange(tab.id)}
                >
                  {tab.icon && <span className="tab-button__icon">{tab.icon}</span>}
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
          <div className="tabbed-modal-layout__body">{children}</div>
        </div>
        {sidebar && <div className="tabbed-modal-layout__sidebar">{sidebar}</div>}
      </div>
    </div>
  );
};

export default TabbedModalLayout;
